export default class InvestorDeck {
  id?: number;
  investorDeckDocument: string;
  personId: number;
  personType: string;

  constructor(entity: InvestorDeck) {
    this.id = entity.id || undefined;
    this.investorDeckDocument = entity.investorDeckDocument;
    this.personId = entity.personId;
    this.personType = entity.personType;
  }}


// WEBPACK FOOTER //
// ./src/entities/InvestorDeck.tsx